module.exports = __webpack_public_path__ + "static/media/desktop_separator_04.5deba296.webp";